var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoxes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 210,
    viewBox: "0 0 224 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.58501,
    cy: 2.58491,
    r: 2.58491,
    transform: "rotate(90 2.58501 2.58491)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.58501,
    cy: 29.4677,
    r: 2.58491,
    transform: "rotate(90 2.58501 29.4677)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.58501,
    cy: 56.3505,
    r: 2.58491,
    transform: "rotate(90 2.58501 56.3505)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.58501,
    cy: 83.2353,
    r: 2.58491,
    transform: "rotate(90 2.58501 83.2353)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.58501,
    cy: 16.0283,
    r: 2.58491,
    transform: "rotate(90 2.58501 16.0283)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.58501,
    cy: 42.9111,
    r: 2.58491,
    transform: "rotate(90 2.58501 42.9111)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.58501,
    cy: 69.7919,
    r: 2.58491,
    transform: "rotate(90 2.58501 69.7919)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.58501,
    cy: 96.6748,
    r: 2.58491,
    transform: "rotate(90 2.58501 96.6748)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.0596,
    cy: 2.58491,
    r: 2.58491,
    transform: "rotate(90 17.0596 2.58491)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.0596,
    cy: 29.4677,
    r: 2.58491,
    transform: "rotate(90 17.0596 29.4677)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.0596,
    cy: 56.3505,
    r: 2.58491,
    transform: "rotate(90 17.0596 56.3505)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.0596,
    cy: 83.2353,
    r: 2.58491,
    transform: "rotate(90 17.0596 83.2353)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.0596,
    cy: 16.0283,
    r: 2.58491,
    transform: "rotate(90 17.0596 16.0283)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.0596,
    cy: 42.9111,
    r: 2.58491,
    transform: "rotate(90 17.0596 42.9111)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.0596,
    cy: 69.7919,
    r: 2.58491,
    transform: "rotate(90 17.0596 69.7919)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.0596,
    cy: 96.6748,
    r: 2.58491,
    transform: "rotate(90 17.0596 96.6748)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5381,
    cy: 2.58491,
    r: 2.58491,
    transform: "rotate(90 31.5381 2.58491)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5381,
    cy: 29.4677,
    r: 2.58491,
    transform: "rotate(90 31.5381 29.4677)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5381,
    cy: 56.3505,
    r: 2.58491,
    transform: "rotate(90 31.5381 56.3505)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5381,
    cy: 83.2353,
    r: 2.58491,
    transform: "rotate(90 31.5381 83.2353)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5381,
    cy: 16.0283,
    r: 2.58491,
    transform: "rotate(90 31.5381 16.0283)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5381,
    cy: 42.9111,
    r: 2.58491,
    transform: "rotate(90 31.5381 42.9111)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5381,
    cy: 69.7919,
    r: 2.58491,
    transform: "rotate(90 31.5381 69.7919)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5381,
    cy: 96.6748,
    r: 2.58491,
    transform: "rotate(90 31.5381 96.6748)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.0127,
    cy: 2.58491,
    r: 2.58491,
    transform: "rotate(90 46.0127 2.58491)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.0127,
    cy: 29.4677,
    r: 2.58491,
    transform: "rotate(90 46.0127 29.4677)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.0127,
    cy: 56.3505,
    r: 2.58491,
    transform: "rotate(90 46.0127 56.3505)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.0127,
    cy: 83.2353,
    r: 2.58491,
    transform: "rotate(90 46.0127 83.2353)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.0127,
    cy: 16.0283,
    r: 2.58491,
    transform: "rotate(90 46.0127 16.0283)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.0127,
    cy: 42.9111,
    r: 2.58491,
    transform: "rotate(90 46.0127 42.9111)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.0127,
    cy: 69.7919,
    r: 2.58491,
    transform: "rotate(90 46.0127 69.7919)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.0127,
    cy: 96.6748,
    r: 2.58491,
    transform: "rotate(90 46.0127 96.6748)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.4854,
    cy: 2.58491,
    r: 2.58491,
    transform: "rotate(90 60.4854 2.58491)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.4854,
    cy: 29.4677,
    r: 2.58491,
    transform: "rotate(90 60.4854 29.4677)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.4854,
    cy: 56.3505,
    r: 2.58491,
    transform: "rotate(90 60.4854 56.3505)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.4854,
    cy: 83.2353,
    r: 2.58491,
    transform: "rotate(90 60.4854 83.2353)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.4854,
    cy: 16.0283,
    r: 2.58491,
    transform: "rotate(90 60.4854 16.0283)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.4854,
    cy: 42.9111,
    r: 2.58491,
    transform: "rotate(90 60.4854 42.9111)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.4854,
    cy: 69.7919,
    r: 2.58491,
    transform: "rotate(90 60.4854 69.7919)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.4854,
    cy: 96.6748,
    r: 2.58491,
    transform: "rotate(90 60.4854 96.6748)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.9639,
    cy: 2.58491,
    r: 2.58491,
    transform: "rotate(90 74.9639 2.58491)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.9639,
    cy: 29.4677,
    r: 2.58491,
    transform: "rotate(90 74.9639 29.4677)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.9639,
    cy: 56.3505,
    r: 2.58491,
    transform: "rotate(90 74.9639 56.3505)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.9639,
    cy: 83.2353,
    r: 2.58491,
    transform: "rotate(90 74.9639 83.2353)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.9639,
    cy: 16.0283,
    r: 2.58491,
    transform: "rotate(90 74.9639 16.0283)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.9639,
    cy: 42.9111,
    r: 2.58491,
    transform: "rotate(90 74.9639 42.9111)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.9639,
    cy: 69.7919,
    r: 2.58491,
    transform: "rotate(90 74.9639 69.7919)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.9639,
    cy: 96.6748,
    r: 2.58491,
    transform: "rotate(90 74.9639 96.6748)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4385,
    cy: 2.58491,
    r: 2.58491,
    transform: "rotate(90 89.4385 2.58491)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4385,
    cy: 29.4677,
    r: 2.58491,
    transform: "rotate(90 89.4385 29.4677)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4385,
    cy: 56.3505,
    r: 2.58491,
    transform: "rotate(90 89.4385 56.3505)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4385,
    cy: 83.2353,
    r: 2.58491,
    transform: "rotate(90 89.4385 83.2353)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4385,
    cy: 16.0283,
    r: 2.58491,
    transform: "rotate(90 89.4385 16.0283)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4385,
    cy: 42.9111,
    r: 2.58491,
    transform: "rotate(90 89.4385 42.9111)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4385,
    cy: 69.7919,
    r: 2.58491,
    transform: "rotate(90 89.4385 69.7919)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4385,
    cy: 96.6748,
    r: 2.58491,
    transform: "rotate(90 89.4385 96.6748)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103.913,
    cy: 2.58491,
    r: 2.58491,
    transform: "rotate(90 103.913 2.58491)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103.913,
    cy: 29.4677,
    r: 2.58491,
    transform: "rotate(90 103.913 29.4677)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103.913,
    cy: 56.3505,
    r: 2.58491,
    transform: "rotate(90 103.913 56.3505)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103.913,
    cy: 83.2353,
    r: 2.58491,
    transform: "rotate(90 103.913 83.2353)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103.913,
    cy: 16.0283,
    r: 2.58491,
    transform: "rotate(90 103.913 16.0283)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103.913,
    cy: 42.9111,
    r: 2.58491,
    transform: "rotate(90 103.913 42.9111)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103.913,
    cy: 69.7919,
    r: 2.58491,
    transform: "rotate(90 103.913 69.7919)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103.913,
    cy: 96.6748,
    r: 2.58491,
    transform: "rotate(90 103.913 96.6748)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.58501,
    cy: 112.585,
    r: 2.58491,
    transform: "rotate(90 2.58501 112.585)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.58501,
    cy: 139.468,
    r: 2.58491,
    transform: "rotate(90 2.58501 139.468)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.58501,
    cy: 166.351,
    r: 2.58491,
    transform: "rotate(90 2.58501 166.351)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.58501,
    cy: 193.235,
    r: 2.58491,
    transform: "rotate(90 2.58501 193.235)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.58501,
    cy: 126.028,
    r: 2.58491,
    transform: "rotate(90 2.58501 126.028)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.58501,
    cy: 152.911,
    r: 2.58491,
    transform: "rotate(90 2.58501 152.911)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.58501,
    cy: 179.792,
    r: 2.58491,
    transform: "rotate(90 2.58501 179.792)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.58501,
    cy: 206.675,
    r: 2.58491,
    transform: "rotate(90 2.58501 206.675)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.0596,
    cy: 112.585,
    r: 2.58491,
    transform: "rotate(90 17.0596 112.585)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.0596,
    cy: 139.468,
    r: 2.58491,
    transform: "rotate(90 17.0596 139.468)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.0596,
    cy: 166.351,
    r: 2.58491,
    transform: "rotate(90 17.0596 166.351)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.0596,
    cy: 193.235,
    r: 2.58491,
    transform: "rotate(90 17.0596 193.235)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.0596,
    cy: 126.028,
    r: 2.58491,
    transform: "rotate(90 17.0596 126.028)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.0596,
    cy: 152.911,
    r: 2.58491,
    transform: "rotate(90 17.0596 152.911)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.0596,
    cy: 179.792,
    r: 2.58491,
    transform: "rotate(90 17.0596 179.792)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.0596,
    cy: 206.675,
    r: 2.58491,
    transform: "rotate(90 17.0596 206.675)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5381,
    cy: 112.585,
    r: 2.58491,
    transform: "rotate(90 31.5381 112.585)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5381,
    cy: 139.468,
    r: 2.58491,
    transform: "rotate(90 31.5381 139.468)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5381,
    cy: 166.351,
    r: 2.58491,
    transform: "rotate(90 31.5381 166.351)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5381,
    cy: 193.235,
    r: 2.58491,
    transform: "rotate(90 31.5381 193.235)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5381,
    cy: 126.028,
    r: 2.58491,
    transform: "rotate(90 31.5381 126.028)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5381,
    cy: 152.911,
    r: 2.58491,
    transform: "rotate(90 31.5381 152.911)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5381,
    cy: 179.792,
    r: 2.58491,
    transform: "rotate(90 31.5381 179.792)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5381,
    cy: 206.675,
    r: 2.58491,
    transform: "rotate(90 31.5381 206.675)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.0127,
    cy: 112.585,
    r: 2.58491,
    transform: "rotate(90 46.0127 112.585)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.0127,
    cy: 139.468,
    r: 2.58491,
    transform: "rotate(90 46.0127 139.468)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.0127,
    cy: 166.351,
    r: 2.58491,
    transform: "rotate(90 46.0127 166.351)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.0127,
    cy: 193.235,
    r: 2.58491,
    transform: "rotate(90 46.0127 193.235)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.0127,
    cy: 126.028,
    r: 2.58491,
    transform: "rotate(90 46.0127 126.028)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.0127,
    cy: 152.911,
    r: 2.58491,
    transform: "rotate(90 46.0127 152.911)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.0127,
    cy: 179.792,
    r: 2.58491,
    transform: "rotate(90 46.0127 179.792)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.0127,
    cy: 206.675,
    r: 2.58491,
    transform: "rotate(90 46.0127 206.675)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.4854,
    cy: 112.585,
    r: 2.58491,
    transform: "rotate(90 60.4854 112.585)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.4854,
    cy: 139.468,
    r: 2.58491,
    transform: "rotate(90 60.4854 139.468)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.4854,
    cy: 166.351,
    r: 2.58491,
    transform: "rotate(90 60.4854 166.351)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.4854,
    cy: 193.235,
    r: 2.58491,
    transform: "rotate(90 60.4854 193.235)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.4854,
    cy: 126.028,
    r: 2.58491,
    transform: "rotate(90 60.4854 126.028)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.4854,
    cy: 152.911,
    r: 2.58491,
    transform: "rotate(90 60.4854 152.911)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.4854,
    cy: 179.792,
    r: 2.58491,
    transform: "rotate(90 60.4854 179.792)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.4854,
    cy: 206.675,
    r: 2.58491,
    transform: "rotate(90 60.4854 206.675)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.9639,
    cy: 112.585,
    r: 2.58491,
    transform: "rotate(90 74.9639 112.585)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.9639,
    cy: 139.468,
    r: 2.58491,
    transform: "rotate(90 74.9639 139.468)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.9639,
    cy: 166.351,
    r: 2.58491,
    transform: "rotate(90 74.9639 166.351)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.9639,
    cy: 193.235,
    r: 2.58491,
    transform: "rotate(90 74.9639 193.235)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.9639,
    cy: 126.028,
    r: 2.58491,
    transform: "rotate(90 74.9639 126.028)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.9639,
    cy: 152.911,
    r: 2.58491,
    transform: "rotate(90 74.9639 152.911)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.9639,
    cy: 179.792,
    r: 2.58491,
    transform: "rotate(90 74.9639 179.792)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.9639,
    cy: 206.675,
    r: 2.58491,
    transform: "rotate(90 74.9639 206.675)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4385,
    cy: 112.585,
    r: 2.58491,
    transform: "rotate(90 89.4385 112.585)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4385,
    cy: 139.468,
    r: 2.58491,
    transform: "rotate(90 89.4385 139.468)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4385,
    cy: 166.351,
    r: 2.58491,
    transform: "rotate(90 89.4385 166.351)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4385,
    cy: 193.235,
    r: 2.58491,
    transform: "rotate(90 89.4385 193.235)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4385,
    cy: 126.028,
    r: 2.58491,
    transform: "rotate(90 89.4385 126.028)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4385,
    cy: 152.911,
    r: 2.58491,
    transform: "rotate(90 89.4385 152.911)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4385,
    cy: 179.792,
    r: 2.58491,
    transform: "rotate(90 89.4385 179.792)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.4385,
    cy: 206.675,
    r: 2.58491,
    transform: "rotate(90 89.4385 206.675)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103.913,
    cy: 112.585,
    r: 2.58491,
    transform: "rotate(90 103.913 112.585)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103.913,
    cy: 139.468,
    r: 2.58491,
    transform: "rotate(90 103.913 139.468)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103.913,
    cy: 166.351,
    r: 2.58491,
    transform: "rotate(90 103.913 166.351)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103.913,
    cy: 193.235,
    r: 2.58491,
    transform: "rotate(90 103.913 193.235)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103.913,
    cy: 126.028,
    r: 2.58491,
    transform: "rotate(90 103.913 126.028)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103.913,
    cy: 152.911,
    r: 2.58491,
    transform: "rotate(90 103.913 152.911)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103.913,
    cy: 179.792,
    r: 2.58491,
    transform: "rotate(90 103.913 179.792)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103.913,
    cy: 206.675,
    r: 2.58491,
    transform: "rotate(90 103.913 206.675)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 119.585,
    cy: 2.58491,
    r: 2.58491,
    transform: "rotate(90 119.585 2.58491)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 119.585,
    cy: 29.4677,
    r: 2.58491,
    transform: "rotate(90 119.585 29.4677)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 119.585,
    cy: 56.3505,
    r: 2.58491,
    transform: "rotate(90 119.585 56.3505)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 119.585,
    cy: 83.2353,
    r: 2.58491,
    transform: "rotate(90 119.585 83.2353)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 119.585,
    cy: 16.0283,
    r: 2.58491,
    transform: "rotate(90 119.585 16.0283)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 119.585,
    cy: 42.9111,
    r: 2.58491,
    transform: "rotate(90 119.585 42.9111)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 119.585,
    cy: 69.7919,
    r: 2.58491,
    transform: "rotate(90 119.585 69.7919)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 119.585,
    cy: 96.6748,
    r: 2.58491,
    transform: "rotate(90 119.585 96.6748)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.06,
    cy: 2.58491,
    r: 2.58491,
    transform: "rotate(90 134.06 2.58491)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.06,
    cy: 29.4677,
    r: 2.58491,
    transform: "rotate(90 134.06 29.4677)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.06,
    cy: 56.3505,
    r: 2.58491,
    transform: "rotate(90 134.06 56.3505)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.06,
    cy: 83.2353,
    r: 2.58491,
    transform: "rotate(90 134.06 83.2353)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.06,
    cy: 16.0283,
    r: 2.58491,
    transform: "rotate(90 134.06 16.0283)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.06,
    cy: 42.9111,
    r: 2.58491,
    transform: "rotate(90 134.06 42.9111)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.06,
    cy: 69.7919,
    r: 2.58491,
    transform: "rotate(90 134.06 69.7919)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.06,
    cy: 96.6748,
    r: 2.58491,
    transform: "rotate(90 134.06 96.6748)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.538,
    cy: 2.58491,
    r: 2.58491,
    transform: "rotate(90 148.538 2.58491)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.538,
    cy: 29.4677,
    r: 2.58491,
    transform: "rotate(90 148.538 29.4677)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.538,
    cy: 56.3505,
    r: 2.58491,
    transform: "rotate(90 148.538 56.3505)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.538,
    cy: 83.2353,
    r: 2.58491,
    transform: "rotate(90 148.538 83.2353)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.538,
    cy: 16.0283,
    r: 2.58491,
    transform: "rotate(90 148.538 16.0283)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.538,
    cy: 42.9111,
    r: 2.58491,
    transform: "rotate(90 148.538 42.9111)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.538,
    cy: 69.7919,
    r: 2.58491,
    transform: "rotate(90 148.538 69.7919)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.538,
    cy: 96.6748,
    r: 2.58491,
    transform: "rotate(90 148.538 96.6748)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 163.013,
    cy: 2.58491,
    r: 2.58491,
    transform: "rotate(90 163.013 2.58491)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 163.013,
    cy: 29.4677,
    r: 2.58491,
    transform: "rotate(90 163.013 29.4677)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 163.013,
    cy: 56.3505,
    r: 2.58491,
    transform: "rotate(90 163.013 56.3505)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 163.013,
    cy: 83.2353,
    r: 2.58491,
    transform: "rotate(90 163.013 83.2353)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 163.013,
    cy: 16.0283,
    r: 2.58491,
    transform: "rotate(90 163.013 16.0283)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 163.013,
    cy: 42.9111,
    r: 2.58491,
    transform: "rotate(90 163.013 42.9111)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 163.013,
    cy: 69.7919,
    r: 2.58491,
    transform: "rotate(90 163.013 69.7919)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 163.013,
    cy: 96.6748,
    r: 2.58491,
    transform: "rotate(90 163.013 96.6748)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177.485,
    cy: 2.58491,
    r: 2.58491,
    transform: "rotate(90 177.485 2.58491)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177.485,
    cy: 29.4677,
    r: 2.58491,
    transform: "rotate(90 177.485 29.4677)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177.485,
    cy: 56.3505,
    r: 2.58491,
    transform: "rotate(90 177.485 56.3505)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177.485,
    cy: 83.2353,
    r: 2.58491,
    transform: "rotate(90 177.485 83.2353)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177.485,
    cy: 16.0283,
    r: 2.58491,
    transform: "rotate(90 177.485 16.0283)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177.485,
    cy: 42.9111,
    r: 2.58491,
    transform: "rotate(90 177.485 42.9111)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177.485,
    cy: 69.7919,
    r: 2.58491,
    transform: "rotate(90 177.485 69.7919)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177.485,
    cy: 96.6748,
    r: 2.58491,
    transform: "rotate(90 177.485 96.6748)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191.964,
    cy: 2.58491,
    r: 2.58491,
    transform: "rotate(90 191.964 2.58491)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191.964,
    cy: 29.4677,
    r: 2.58491,
    transform: "rotate(90 191.964 29.4677)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191.964,
    cy: 56.3505,
    r: 2.58491,
    transform: "rotate(90 191.964 56.3505)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191.964,
    cy: 83.2353,
    r: 2.58491,
    transform: "rotate(90 191.964 83.2353)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191.964,
    cy: 16.0283,
    r: 2.58491,
    transform: "rotate(90 191.964 16.0283)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191.964,
    cy: 42.9111,
    r: 2.58491,
    transform: "rotate(90 191.964 42.9111)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191.964,
    cy: 69.7919,
    r: 2.58491,
    transform: "rotate(90 191.964 69.7919)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191.964,
    cy: 96.6748,
    r: 2.58491,
    transform: "rotate(90 191.964 96.6748)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.439,
    cy: 2.58491,
    r: 2.58491,
    transform: "rotate(90 206.439 2.58491)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.439,
    cy: 29.4677,
    r: 2.58491,
    transform: "rotate(90 206.439 29.4677)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.439,
    cy: 56.3505,
    r: 2.58491,
    transform: "rotate(90 206.439 56.3505)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.439,
    cy: 83.2353,
    r: 2.58491,
    transform: "rotate(90 206.439 83.2353)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.439,
    cy: 16.0283,
    r: 2.58491,
    transform: "rotate(90 206.439 16.0283)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.439,
    cy: 42.9111,
    r: 2.58491,
    transform: "rotate(90 206.439 42.9111)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.439,
    cy: 69.7919,
    r: 2.58491,
    transform: "rotate(90 206.439 69.7919)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.439,
    cy: 96.6748,
    r: 2.58491,
    transform: "rotate(90 206.439 96.6748)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220.913,
    cy: 2.58491,
    r: 2.58491,
    transform: "rotate(90 220.913 2.58491)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220.913,
    cy: 29.4677,
    r: 2.58491,
    transform: "rotate(90 220.913 29.4677)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220.913,
    cy: 56.3505,
    r: 2.58491,
    transform: "rotate(90 220.913 56.3505)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220.913,
    cy: 83.2353,
    r: 2.58491,
    transform: "rotate(90 220.913 83.2353)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220.913,
    cy: 16.0283,
    r: 2.58491,
    transform: "rotate(90 220.913 16.0283)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220.913,
    cy: 42.9111,
    r: 2.58491,
    transform: "rotate(90 220.913 42.9111)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220.913,
    cy: 69.7919,
    r: 2.58491,
    transform: "rotate(90 220.913 69.7919)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220.913,
    cy: 96.6748,
    r: 2.58491,
    transform: "rotate(90 220.913 96.6748)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 119.585,
    cy: 112.585,
    r: 2.58491,
    transform: "rotate(90 119.585 112.585)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 119.585,
    cy: 139.468,
    r: 2.58491,
    transform: "rotate(90 119.585 139.468)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 119.585,
    cy: 166.351,
    r: 2.58491,
    transform: "rotate(90 119.585 166.351)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 119.585,
    cy: 193.235,
    r: 2.58491,
    transform: "rotate(90 119.585 193.235)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 119.585,
    cy: 126.028,
    r: 2.58491,
    transform: "rotate(90 119.585 126.028)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 119.585,
    cy: 152.911,
    r: 2.58491,
    transform: "rotate(90 119.585 152.911)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 119.585,
    cy: 179.792,
    r: 2.58491,
    transform: "rotate(90 119.585 179.792)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 119.585,
    cy: 206.675,
    r: 2.58491,
    transform: "rotate(90 119.585 206.675)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.06,
    cy: 112.585,
    r: 2.58491,
    transform: "rotate(90 134.06 112.585)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.06,
    cy: 139.468,
    r: 2.58491,
    transform: "rotate(90 134.06 139.468)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.06,
    cy: 166.351,
    r: 2.58491,
    transform: "rotate(90 134.06 166.351)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.06,
    cy: 193.235,
    r: 2.58491,
    transform: "rotate(90 134.06 193.235)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.06,
    cy: 126.028,
    r: 2.58491,
    transform: "rotate(90 134.06 126.028)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.06,
    cy: 152.911,
    r: 2.58491,
    transform: "rotate(90 134.06 152.911)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.06,
    cy: 179.792,
    r: 2.58491,
    transform: "rotate(90 134.06 179.792)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134.06,
    cy: 206.675,
    r: 2.58491,
    transform: "rotate(90 134.06 206.675)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.538,
    cy: 112.585,
    r: 2.58491,
    transform: "rotate(90 148.538 112.585)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.538,
    cy: 139.468,
    r: 2.58491,
    transform: "rotate(90 148.538 139.468)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.538,
    cy: 166.351,
    r: 2.58491,
    transform: "rotate(90 148.538 166.351)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.538,
    cy: 193.235,
    r: 2.58491,
    transform: "rotate(90 148.538 193.235)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.538,
    cy: 126.028,
    r: 2.58491,
    transform: "rotate(90 148.538 126.028)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.538,
    cy: 152.911,
    r: 2.58491,
    transform: "rotate(90 148.538 152.911)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.538,
    cy: 179.792,
    r: 2.58491,
    transform: "rotate(90 148.538 179.792)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.538,
    cy: 206.675,
    r: 2.58491,
    transform: "rotate(90 148.538 206.675)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 163.013,
    cy: 112.585,
    r: 2.58491,
    transform: "rotate(90 163.013 112.585)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 163.013,
    cy: 139.468,
    r: 2.58491,
    transform: "rotate(90 163.013 139.468)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 163.013,
    cy: 166.351,
    r: 2.58491,
    transform: "rotate(90 163.013 166.351)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 163.013,
    cy: 193.235,
    r: 2.58491,
    transform: "rotate(90 163.013 193.235)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 163.013,
    cy: 126.028,
    r: 2.58491,
    transform: "rotate(90 163.013 126.028)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 163.013,
    cy: 152.911,
    r: 2.58491,
    transform: "rotate(90 163.013 152.911)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 163.013,
    cy: 179.792,
    r: 2.58491,
    transform: "rotate(90 163.013 179.792)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 163.013,
    cy: 206.675,
    r: 2.58491,
    transform: "rotate(90 163.013 206.675)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177.485,
    cy: 112.585,
    r: 2.58491,
    transform: "rotate(90 177.485 112.585)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177.485,
    cy: 139.468,
    r: 2.58491,
    transform: "rotate(90 177.485 139.468)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177.485,
    cy: 166.351,
    r: 2.58491,
    transform: "rotate(90 177.485 166.351)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177.485,
    cy: 193.235,
    r: 2.58491,
    transform: "rotate(90 177.485 193.235)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177.485,
    cy: 126.028,
    r: 2.58491,
    transform: "rotate(90 177.485 126.028)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177.485,
    cy: 152.911,
    r: 2.58491,
    transform: "rotate(90 177.485 152.911)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177.485,
    cy: 179.792,
    r: 2.58491,
    transform: "rotate(90 177.485 179.792)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177.485,
    cy: 206.675,
    r: 2.58491,
    transform: "rotate(90 177.485 206.675)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191.964,
    cy: 112.585,
    r: 2.58491,
    transform: "rotate(90 191.964 112.585)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191.964,
    cy: 139.468,
    r: 2.58491,
    transform: "rotate(90 191.964 139.468)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191.964,
    cy: 166.351,
    r: 2.58491,
    transform: "rotate(90 191.964 166.351)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191.964,
    cy: 193.235,
    r: 2.58491,
    transform: "rotate(90 191.964 193.235)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191.964,
    cy: 126.028,
    r: 2.58491,
    transform: "rotate(90 191.964 126.028)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191.964,
    cy: 152.911,
    r: 2.58491,
    transform: "rotate(90 191.964 152.911)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191.964,
    cy: 179.792,
    r: 2.58491,
    transform: "rotate(90 191.964 179.792)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191.964,
    cy: 206.675,
    r: 2.58491,
    transform: "rotate(90 191.964 206.675)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.439,
    cy: 112.585,
    r: 2.58491,
    transform: "rotate(90 206.439 112.585)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.439,
    cy: 139.468,
    r: 2.58491,
    transform: "rotate(90 206.439 139.468)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.439,
    cy: 166.351,
    r: 2.58491,
    transform: "rotate(90 206.439 166.351)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.439,
    cy: 193.235,
    r: 2.58491,
    transform: "rotate(90 206.439 193.235)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.439,
    cy: 126.028,
    r: 2.58491,
    transform: "rotate(90 206.439 126.028)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.439,
    cy: 152.911,
    r: 2.58491,
    transform: "rotate(90 206.439 152.911)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.439,
    cy: 179.792,
    r: 2.58491,
    transform: "rotate(90 206.439 179.792)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.439,
    cy: 206.675,
    r: 2.58491,
    transform: "rotate(90 206.439 206.675)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220.913,
    cy: 112.585,
    r: 2.58491,
    transform: "rotate(90 220.913 112.585)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220.913,
    cy: 139.468,
    r: 2.58491,
    transform: "rotate(90 220.913 139.468)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220.913,
    cy: 166.351,
    r: 2.58491,
    transform: "rotate(90 220.913 166.351)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220.913,
    cy: 193.235,
    r: 2.58491,
    transform: "rotate(90 220.913 193.235)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220.913,
    cy: 126.028,
    r: 2.58491,
    transform: "rotate(90 220.913 126.028)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220.913,
    cy: 152.911,
    r: 2.58491,
    transform: "rotate(90 220.913 152.911)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220.913,
    cy: 179.792,
    r: 2.58491,
    transform: "rotate(90 220.913 179.792)",
    fill: "#F69F7F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220.913,
    cy: 206.675,
    r: 2.58491,
    transform: "rotate(90 220.913 206.675)",
    fill: "#F69F7F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxes);
export default __webpack_public_path__ + "static/media/Boxes.c11b0f93789d0c4881e1409fd957fdcd.svg";
export { ForwardRef as ReactComponent };